import { useEffect } from 'react';
import { useLayoutIds } from 'view/layout-next/controllers';

const useSectionAndElementId = (elementTypeName: string, sectionId: string, elementId: string) => {
	const [_, { setLayoutId }] = useLayoutIds();

	useEffect(() => {
		if (elementId && sectionId && elementTypeName) {
			setLayoutId(sectionId, elementId, elementTypeName);
		}
	}, [sectionId, elementTypeName, elementId, setLayoutId]);
};
export default useSectionAndElementId;
